import React from "react";

import styles from "./Button.module.css";

export const BUTTON_STYLES = {
  DANGER: styles.danger,
  PRIMARY: styles.primary,
  SECONDARY: styles.secondary,
  NO_BORDER: styles.noBorder,
}

const Button = ({ text, icon, onClick, disabled, style, className }) => {
  let classes = [styles.button];
  if (className) classes.push(className);
  if (disabled) classes.push(styles.disabled);
  if (style) classes.push(style);

  const finalClass = classes.join(" ");

  return (
    <div className={finalClass} onClick={disabled ? undefined : onClick}>
      {icon && <i className={icon}></i>} {text}
    </div>
  );
};

export default Button;
